import { HourlyProductionCard } from "./HourlyProductionCard";
export default HourlyProductionCard;
